module.exports = __webpack_public_path__ + "static/body-bg-e2a9be20a4a7f87219b2aca9adace724.png";